import React from "react";
import {SelectRectangleLayer} from "../../../../../base-konva/components/SelectRectangleLayer";
import {useSelector} from "react-redux";
import {selectPlanUploadStageConfig} from "../config/planUploadConfigSlice";
import {selectPlanUploadPanInProgress} from "../view/planUploadViewSlice";
import {usePlanUploadEraseArea} from "./usePlanUploadEraseArea";

const PlanUploadEraseAreaLayer: React.FC = () => {
	const stageConfig = useSelector(selectPlanUploadStageConfig);
	const panInProgress = useSelector(selectPlanUploadPanInProgress);

	return (
		<SelectRectangleLayer correspondingHook={usePlanUploadEraseArea} stageConfig={stageConfig} panInProgress={panInProgress}/>
	)
}

export {PlanUploadEraseAreaLayer}